import React from "react";
import { injectIntl, FormattedDate, FormattedTime } from "react-intl";
import { Row, Col, Glyphicon } from "react-bootstrap";

function Activity({ intl, activity }) {
  const activityName = activity.activityName;
  const specificName = activity.name;
  const name = specificName + " (" + activityName + ")";
  return (
    <React.Fragment>
      <Row id="activity-details">
        <Col xs={12}>
          <span className="bold">{intl.formatMessage({ id: "name" })}</span>
        </Col>
        <Col className="activity-field" xs={12}>
          {name}
        </Col>
        <Col xs={12}>
          <span className="bold">
            {intl.formatMessage({ id: "description" })}
          </span>
        </Col>
        <Col className="activity-field" xs={12}>
          {activity.activityDescription}
        </Col>
        <Col xs={12}>
          <span className="bold">
            {intl.formatMessage({ id: "additional_information" })}
          </span>
        </Col>
        <Col className="activity-field" xs={12}>
          {activity.customDescription}
        </Col>
        <Col xs={12}>
          <span className="bold">{intl.formatMessage({ id: "location" })}</span>
        </Col>
        <Col className="activity-field" xs={12}>
          {activity.place}
        </Col>
      </Row>

      <Row id="activity-vision-details">
        <Col xs={12} md={6}>
          <span className="bold">
            <Glyphicon glyph="calendar" />
            &nbsp;&nbsp; {intl.formatMessage({ id: "start_date" })}
          </span>
          &nbsp;&nbsp;
          <FormattedDate value={activity.startDate} />
          &nbsp;
          <FormattedTime value={activity.startDate} hour12={true} />
        </Col>
        <Col className="activity-field" xs={12} md={6}>
          <span className="bold">
            <Glyphicon glyph="calendar" />
            &nbsp;&nbsp; {intl.formatMessage({ id: "finish_date" })}
          </span>{" "}
          &nbsp;&nbsp;
          <FormattedDate value={activity.finishDate} />
          &nbsp;
          <FormattedTime value={activity.finishDate} hour12={true} />
        </Col>

        <Col xs={12}>
          <span className="bold">{intl.formatMessage({ id: "goals" })}</span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.goals.map((card, idx) => (
              <li key={idx}>
                <span className="bold">{card.name}:&nbsp;</span>
                {card.description}.&nbsp;
                <em>({activity.getDetails(card.id)})</em>
              </li>
            ))}
          </ul>
        </Col>

        <Col xs={12}>
          <span className="bold">{intl.formatMessage({ id: "measure" })}</span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.measure.map((el, idx) => (
              <li key={idx}>{el.description}</li>
            ))}
          </ul>
        </Col>

        <Col xs={12}>
          <span className="bold">{intl.formatMessage({ id: "offers" })}</span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.offers.map((card, idx) => (
              <li key={idx}>
                <span className="bold">{card.name}:&nbsp;</span>
                {card.description}.&nbsp;
                <em>({activity.getDetails(card.id)})</em>
              </li>
            ))}
          </ul>
        </Col>
      </Row>

      <Row id="activity-connections">
        <Col xs={12}>
          <span className="bold">
            {intl.formatMessage({ id: "customers" })}
          </span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.customers.map((card, idx) => (
              <li key={idx}>
                <span className="bold">{card.name}:&nbsp;</span>
                {card.description}.&nbsp;
                <em>({activity.getDetails(card.id)})</em>
              </li>
            ))}
          </ul>
        </Col>

        <Col xs={12}>
          <span className="bold">
            {intl.formatMessage({ id: "invitation" })}
          </span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.invitation.map((card, idx) => (
              <li key={idx}>
                <span className="bold">{card.name}:&nbsp;</span>
                {card.description}.&nbsp;
                <em>({activity.getDetails(card.id)})</em>
              </li>
            ))}
          </ul>
        </Col>

        <Col xs={12}>
          <span className="bold">
            {intl.formatMessage({ id: "connection" })}
          </span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.connection.map((card, idx) => (
              <li key={idx}>
                <span className="bold">{card.name}:&nbsp;</span>
                {card.description}.&nbsp;
                <em>({activity.getDetails(card.id)})</em>
              </li>
            ))}
          </ul>
        </Col>

        <Col xs={12}>
          <span className="bold">
            {intl.formatMessage({ id: "resources" })}
          </span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.resources.map((card, idx) => (
              <li key={idx}>
                <span className="bold">{card.name}:&nbsp;</span>
                {card.description}.&nbsp;
                <em>({activity.getDetails(card.id)})</em>
              </li>
            ))}
          </ul>
        </Col>
      </Row>

      <Row id="activity-last-details">
        <Col xs={12}>
          <span className="bold">{intl.formatMessage({ id: "partners" })}</span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.partners.map((card, idx) => (
              <li key={idx}>
                <span className="bold">{card.name}:&nbsp;</span>
                {card.description}.&nbsp;
                <em>({activity.getDetails(card.id)})</em>
              </li>
            ))}
          </ul>
        </Col>

        <Col xs={12}>
          <span className="bold">
            {intl.formatMessage({ id: "cost_structure" })}
          </span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.costStructure.map((card, idx) => (
              <li key={idx}>
                <span className="bold">{card.name}:&nbsp;</span>
                {card.description}.&nbsp;
                <em>({activity.getDetails(card.id)})</em>
              </li>
            ))}
          </ul>
        </Col>

        <Col xs={12}>
          <span className="bold">
            {intl.formatMessage({ id: "detailed_costs" })}
          </span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.costs.map((el, idx) => (
              <li key={idx}>
                <span>{el.description}:</span>
                {el.value}
              </li>
            ))}
          </ul>
        </Col>

        <Col xs={12}>
          <span className="bold">{intl.formatMessage({ id: "learn" })}</span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.learn.map((el, idx) => (
              <li key={idx}>{el.description}</li>
            ))}
          </ul>
        </Col>

        <Col xs={12}>
          <span className="bold">{intl.formatMessage({ id: "build" })}</span>
        </Col>
        <Col className="activity-field" xs={12}>
          <ul>
            {activity.build.map((el, idx) => (
              <li key={idx}>{el.description}</li>
            ))}
          </ul>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default injectIntl(Activity);
